export interface ApiErrorBody {
  error?: { code?: string; message?: string; requestId?: string };
}

export class ApiError extends Error {
  public constructor(
    public readonly status: number,
    public readonly code: string,
    message: string,
    public readonly requestId?: string,
  ) {
    super(message);
  }
}

function csrfToken(): string | undefined {
  return document.cookie
    .split(";")
    .map((value) => value.trim())
    .find((value) => value.startsWith("lv_csrf="))
    ?.slice("lv_csrf=".length);
}

export async function api<T>(path: string, init: RequestInit = {}): Promise<T> {
  const method = (init.method ?? "GET").toUpperCase();
  const csrf = csrfToken();
  const isFormData = typeof FormData !== "undefined" && init.body instanceof FormData;
  const response = await fetch(path, {
    ...init,
    credentials: "same-origin",
    headers: {
      ...(init.body && !isFormData ? { "content-type": "application/json" } : {}),
      ...(!["GET", "HEAD", "OPTIONS"].includes(method) && csrf ? { "x-csrf-token": csrf } : {}),
      ...init.headers,
    },
  });
  const body = (await response.json().catch(() => ({}))) as T | ApiErrorBody;
  if (!response.ok) {
    const error = body as ApiErrorBody;
    throw new ApiError(
      response.status,
      error.error?.code ?? "request-failed",
      error.error?.message ?? `Request failed with HTTP ${response.status}`,
      error.error?.requestId,
    );
  }
  return body as T;
}
